<template>
  <div class="big_data">
    <Header></Header>
    <Banners :banner="banner"></Banners>

    <div class="part part1">
      <p class="title">保险业务赋能</p>
      <p class="content">通过专业数据分析能力，协助保险机构将其存量静默用户重新激活，引导投保，变成活跃在保用户，从而实现存量用户的盘活与转化。</p>

      <!-- <img v-for="(item,index) in part1" :src="item" :key="item" alt=""> -->

    </div>
    <!-- <div class="part part2">
      <p class="title">保险经纪代理公司赋能</p>

      <img v-for="(item,index) in part2" :src="item" :key="item" alt="">
    </div> -->
    <div class="part part3">
      <p class="title">异业转化赋能</p>

      <img v-for="(item,index) in part3" :src="item" :key="item" alt="">
      <p class="content">依托资源与技术的高效融合，支持保险机构通过多样化手段将非保险业务存量用户转化保险用户，从而提升保险机构的业务营销广度与深度。</p>
    </div>

    <!-- <div class="part part4">
      <p class="title">健康赋能-电话医生</p>

      <img v-for="(item,index) in part4" :src="item" :key="item" alt="">
    </div> -->

    <Footer></Footer>
  </div>
</template>

<script>
  import Header from "@/mComponents/Header"
  import Banners from "@/mComponents/Banners"
  import Footer from "@/mComponents/Footer"

  export default {
    name: 'Big_Data',
    data() {
      return {
        banner: require("@/assets/imgs/mobile/banner-03.png"),
        img3: require("@/assets/imgs/mobile/img-cup.png"),
        part1: [
          require("@/assets/imgs/mobile/fea07.png"),
          require("@/assets/imgs/mobile/fea08.png"),
        ],
        part2:[
          require("@/assets/imgs/mobile/fea01.png"),
          require("@/assets/imgs/mobile/fea02.png"),
          require("@/assets/imgs/mobile/fea03.png"),
          require("@/assets/imgs/mobile/fea04.png"),
        ],
        part3: [
          require("@/assets/imgs/mobile/fea09.png"),
        ],
        part4: [
          require("@/assets/imgs/mobile/fea05.png"),
          require("@/assets/imgs/mobile/fea06.png"),
        ]
      }
    },
    components: {
      Header,Banners,Footer,
    },
    created() {
      window.scrollTo(0,0);
      this.$store.commit('changeNavsM', 'mBig_Data')
    },
    methods: {
      noClick() {
        return false;
      }
    },
    mounted() {
      $('.part1 ul li').addClass("active");
      var screenHeight =  document.documentElement.clientHeight
      setTimeout(function() {
        window.onscroll = function() {
          var bool = $(window).scrollTop()+$(window).height()==$(document).height();
          var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          let fontSize = getComputedStyle(window.document.documentElement)['font-size'];
          if(scrollTop>30) {
            $(".icon-m-up").css("display","block")
            $(".top").addClass("active")
          } else {
            $(".icon-m-up").css("display","none")
            $(".top").removeClass("active")
          }
          var lis = $('.part4 ul li')
          for(var i =0;i<lis.length;i++) {
            var offsetTop = $(lis[i]).offset().top
            if(offsetTop - scrollTop - screenHeight < 0 && !bool && !$(lis[i]).hasClass('active')) {
              $(lis[i]).addClass('active')
            }
          }
        }
      },100)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped lang="scss" type="text/scss">
  @import '../../assets/css/animation.css';
  .big_data {
    background-color: #fff;

    .clear {
      clear: both;
    }
    .part {
      padding: 0.7rem 0;
      background:rgba(237,237,237,1);
      p {
        text-align: center;
      }
      .title {
        font-size:0.48rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        margin-bottom: 40px;
      }

      .content {
        font-size:0.24rem;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(0,0,0,1);
        line-height: 1.5;
        text-align: center;
        margin: 0 auto;
        max-width: 80%;
      }
      img {
        width: 70%;
        display: block;
        margin: 20px auto 40px;
      }
    }
    .part1 {
      background-color: #fff;
    }
    .part2 {

    }
    .part3 {
      background-color: #fff;
    }
    .part4 {
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Mobile/Big_Data.vue